import {
  SITE_LOADING,
  NOT_FOUND,
  RESET_NOT_FOUND,
  NETWORK_ERROR,
  RESET_NETWORK_ERROR,
  SET_ACTIVE_PAGE,
  RESET_ACTIVE_PAGE,
  UPDATE_DEVICE,
  FETCH_CURRENCIES_SUCCESS,
  FETCH_CURRENCIES_ERROR,
  CLEAR_FETCH_CURRENCIES,
  ACTION_SUCCESS_NOTIFICATION,
  ACTION_ERROR_NOTIFICATION,
  CLEAR_ACTION_NOTIFICATION,
  SET_LAST_PATCHED_ID,
  RESET_LAST_PATCHED_ID,
} from 'redux/common/types';

const initialState = {
  siteLoading: false,
  notFound: false,
  networkError: false,
  activePage: null,
  device: 'desktop',
  currencies: null,
  currenciesError: null,
  actionSuccessNotification: null,
  actionErrorNotification: null,
  lastPatchedId: null,
};


export default (state = initialState, action) => {
  switch (action.type) {
    case SITE_LOADING:
      return {
        ...state,
        siteLoading: action.payload,
      };
    case NOT_FOUND:
      return {
        ...state,
        notFound: true,
      };
    case RESET_NOT_FOUND:
      return {
        ...state,
        notFound: false,
      };
    case NETWORK_ERROR:
      return {
        ...state,
        networkError: true,
      };
    case RESET_NETWORK_ERROR:
      return {
        ...state,
        networkError: false,
      };
    case SET_ACTIVE_PAGE:
      return {
        ...state,
        activePage: action.payload,
      };
    case RESET_ACTIVE_PAGE:
      return {
        ...state,
        activePage: null,
      };
    case UPDATE_DEVICE:
      return {
        ...state,
        device: action.payload,
      };
    case FETCH_CURRENCIES_SUCCESS:
      return {
        ...state,
        currencies: action.payload.data,
        currenciesError: null,
      };
    case FETCH_CURRENCIES_ERROR:
      return {
        ...state,
        currencies: null,
        currenciesError: action.payload.data,
      };
    case CLEAR_FETCH_CURRENCIES:
      return {
        ...state,
        currencies: null,
        currenciesError: null,
      };
    case ACTION_SUCCESS_NOTIFICATION:
      return {
        ...state,
        actionSuccessNotification: action.payload,
      };
    case ACTION_ERROR_NOTIFICATION:
      return {
        ...state,
        actionErrorNotification: action.payload,
      };
    case CLEAR_ACTION_NOTIFICATION:
      return {
        ...state,
        actionSuccessNotification: null,
        actionErrorNotification: null,
      };
    case SET_LAST_PATCHED_ID:
      return {
        ...state,
        lastPatchedId: action.payload,
      };
    case RESET_LAST_PATCHED_ID:
      return {
        ...state,
        lastPatchedId: null,
      };
    default:
      return state;
  }
};
